import React from 'react';
import { BaasicAsyncCreatableSelect, Loader, BaasicInput, BaasicConfirmModal } from 'core/components';
import { renderIf, translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const LinkOrderLineTemplate = ({ linkOrderLineViewStore, t }) => {
	const loading = linkOrderLineViewStore.loading;
	if (loading) return <Loader />;
	const {
		form,
		existingProduct,
		toggleExistingProduct,
		productService,
		rootStore,
		orderLine: {
			id,
			sku,
			sellerId,
			order: { channel },
		},
		linkOrderLineConfirmModal,
		error,
	} = linkOrderLineViewStore;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				{renderIf(!existingProduct)(
					<React.Fragment>
						<div className="ReactModal__header"></div>
						<div className="ReactModal__body">
							<button
								className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
								type="button"
								onClick={() => toggleExistingProduct()}
							>
								{t('LINKORDERLINEVIEW.LINKTOEXISTINGPRODUCT')}
							</button>
							<button
								className="btn btn--med btn--primary spc--bottom--sml"
								type="button"
								onClick={() =>
									rootStore.routerStore.goTo('master.app.main.product.list.add', {
										orderLineId: id,
										orderDetailId: rootStore.routerStore.routerState.params.id,
										channel: channel,
										sku: sku,
										sellerId: sellerId
									})
								}
							>
								{t('LINKORDERLINEVIEW.CREATENEWPRODUCT')}
							</button>
						</div>
					</React.Fragment>
				)}
				{renderIf(existingProduct)(
					<React.Fragment>
						<div className="ReactModal__header">
							<h3 className="spc--bottom--sml">{t('LINKORDERLINEVIEW.TITLE')}</h3>
						</div>
						<div className="ReactModal__body">
							<div className="spc--bottom--sml">
								<BaasicAsyncCreatableSelect
									field={form.$('product')}
									service={productService}
									searchBy={'mainSku'}
								/>
							</div>
							<BaasicInput field={form.$('description')} />
							{error != null && <p className="type--color--warning spc--bottom--sml">{translate(error)}</p>}
							{form.error && <p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>}
						</div>
						<div className="ReactModal__footer">
							<button
								className="btn btn--med btn--primary spc--bottom--sml spc--right--sml"
								type="submit"
								disabled={loading}
							>
								{loading ? (
									<div className="spinnercont spc--right--sml">
										<div className="spinner"></div>
									</div>
								) : null}
								{t('SAVE')}
							</button>
							<button
								className="btn btn--med btn--ghost spc--bottom--sml"
								type="button"
								onClick={() => toggleExistingProduct()}
							>
								{t('BACK')}
							</button>
						</div>
					</React.Fragment>
				)}
				<BaasicConfirmModal modalParams={linkOrderLineConfirmModal} />
			</form>
		</section>
	);
};

export default defaultTemplate(LinkOrderLineTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/LinkOrderLineTemplate.jsx